import * as Campaigns                from '../../campaigns';
import * as UI                       from '../../ui';
import { SendingDescription }        from './sending';
import { usePageContext }            from '../../components/render_page';
import { useScheduledTimeInMinutes } from '../activity_page';
import ConfirmModal                  from '../../components/confirm_modal';
import Link                          from '../../components/link';
import MessagePreview                from './message_preview';
import pluralize                     from '../../util/pluralize';
import React                         from 'react';
import Recipients                    from './recipients';
import useBoolean                    from '../../hooks/use_boolean';


export default function ScheduledStatusPage({ campaign }) {
  const { businessID }         = usePageContext();
  const convertCampaignToDraft = Campaigns.useConvertCampaignToDraft(businessID);
  const toast                  = UI.useToast();

  const [ confirmIsOpen, showConfirm, hideConfirm ] = useBoolean();

  async function onClickConfirm() {
    hideConfirm();
    await convertCampaignToDraft(campaign);
    toast('Campaign saved for later!');
  }

  const { scheduledAt } = campaign;
  const timeInMinutes   = useScheduledTimeInMinutes(scheduledAt);
  const canSaveForLater = timeInMinutes > 0;

  return (
    <>
      {canSaveForLater && <CanSaveForLaterDescription {...{ timeInMinutes, showConfirm }}/>}
      {!canSaveForLater && <SendingDescription/>}
      <Recipients {...{ campaign }}/>
      <MessagePreview {...{ campaign }}/>
      <ConfirmModal
        isOpen={confirmIsOpen}
        closeModal={hideConfirm}
        onConfirm={onClickConfirm}
        title="Stop Campaign"
        description="We’ll cancel sending this campaign and save it as a draft so you can send it later."
        buttonLabel="Stop Campaign"
        buttonClassName="danger"
      />
    </>
  );
}


function CanSaveForLaterDescription({ timeInMinutes, showConfirm }) {
  return (
    <div className="block description">
      <h2>Your campaign will be sent shortly.</h2>
      <p>
        We’ll deliver this email in <strong>{timeInMinutes} {pluralize(timeInMinutes, 'minute')}.</strong> If you change your mind, you can <Link onClick={showConfirm} className="danger">stop this campaign</Link> and save it as a draft to be sent later.
      </p>
    </div>
  );
}
